import React from "react";
import useLocale from "../hooks/useLocale";

function LanguageSwitcher({ compact = false }) {
  const { language, languages, changeLanguage, t } = useLocale();

  return (
    <label className="inline-flex items-center gap-2 text-xs font-semibold text-slate-500">
      {!compact ? <span>{t("app.language")}</span> : null}
      <select
        value={language}
        onChange={(event) => changeLanguage(event.target.value)}
        className="cursor-pointer rounded-xl border border-slate-200 bg-white/90 px-3 py-2 text-xs font-semibold text-slate-700 shadow-sm outline-none transition hover:border-cyan-200 hover:bg-cyan-50 focus:border-cyan-400 focus:ring-4 focus:ring-cyan-100"
        aria-label={t("app.language")}
      >
        {languages.map((item) => (
          <option key={item.code} value={item.code}>
            {t(item.labelKey)}
          </option>
        ))}
      </select>
    </label>
  );
}

export default LanguageSwitcher;
